import React, { useState, useEffect } from 'react';
import ListTables from '../../components/shared/tables';
import Base from '../base';
import { Alert } from '@themesberg/react-bootstrap';
import SearchFormInspect from '../../components/widgets/formSearch';
import { get, post } from '../../services/back.service';
import ModalMessage from '../../components/widgets/modalMessage';
import DownloadButton from '../../components/widgets/downloadButton';
import ReportActions from '../../components/shared/ReportActions';

function ClientInspectionReport() {
  const [infoReport, setInfoReport] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectInspect, setSelectInspect] = useState(0);
  const [currentFilter, setCurrentFilter] = useState({});
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: '',
  });

  const editButton = (row) => {
    return (
      <ReportActions
        showPdf={row.state === 'I'}
        onPdf={() => {
          setAlert({ show: false });
          setShowModal(true);
          setSelectInspect(row.id);
        }}
      />
    );
  };

  const searching = async (data) => {
    setCurrentFilter(data);
    const body = data;
    const respoReport = await post('/peritaje/clientinspectionreport/', body);
    if (respoReport.success) {
      setInfoReport(respoReport.data);
    } else {
      console.log(respoReport);
    }
  };

  useEffect(() => { }, []);

  const generatePdf = async () => {
    const respo = await get('/peritaje/createpdf/' + selectInspect);
    if (respo.success) {
      const element = document.createElement("a");
      element.href = respo.data.urlFile;
      element.click();
      element.remove()
      searching(currentFilter);
    } else {
      setAlert({
        show: true,
        message: respo.message,
        type: 'danger',
      });
    }
    setShowModal(false);
  };

  return (
    <Base>
      {alert.show && (
        <Alert
          variant={alert.type}
          onClose={() => setAlert({ show: false })}
          dismissible
        >
          {alert.message}
        </Alert>
      )}
      <ModalMessage
        title={'Advertencia'}
        text={`Una vez genere el pdf No ${selectInspect}, el peritaje no se podra editar esta seguro?`}
        showProps={showModal}
        funcAccept={generatePdf}
        funcClose={() => setShowModal(false)}
      />
      <SearchFormInspect searching={searching} />
      <DownloadButton infoReport={infoReport} filename={'peritajes.csv'} separator={';'} />
      <ListTables
        data={infoReport}
        editar={editButton}
        messageWd="sin peritajes en el filtro"
        headerAlwaysShow={true}
      />
    </Base>
  );
}

export default ClientInspectionReport;
